import React, { useState, useEffect } from "react";

const StateCodeForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors: apiErrors = {}, 
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [localErrors, setLocalErrors] = useState({});

  useEffect(() => {
    if (apiErrors && Object.keys(apiErrors).length > 0) {
      setLocalErrors(apiErrors);
    }
  }, [apiErrors]);

  const validateField = (name, value) => {
    let error = "";
    if (name === "name") {
      if (!value || value.trim() === "") {
        error = "Name is required";
      } else if (value.length > 50) {
        error = "Name cannot exceed 50 characters";
      }
    } else if (name === "code") {
      if (!value || value.trim() === "") {
        error = "Code is required";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (type !== "checkbox") {
      const error = validateField(name, value);
      setLocalErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nameError = validateField("name", formData.name);
    const codeError = validateField("code", formData.code);

    if (nameError || codeError) {
      setLocalErrors({ name: nameError, code: codeError });
      return;
    }

    const submissionData = new FormData(); 
    submissionData.append("name", formData.name);
    submissionData.append("code", formData.code);
    submissionData.append("is_active", formData.is_active ? 1 : 0); 

    onSubmit(submissionData); 
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      <div>
        <label htmlFor="name" className="block dark:text-white text-sm font-medium text-gray-700">
          Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.name ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.name && <p className="text-red-500 text-sm mt-1">{localErrors.name}</p>}
      </div>

      <div>
        <label htmlFor="code" className="block dark:text-white text-sm font-medium text-gray-700">
          Code <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.code ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.code && <p className="text-red-500 text-sm mt-1">{localErrors.code}</p>}
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="is_active"
          name="is_active"
          checked={formData.is_active}
          onChange={handleChange}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="is_active" className="ml-2 block text-sm font-medium text-gray-700 dark:text-white">
          Is Active
        </label>
      </div>

      <div className="flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading || Object.values(localErrors).some(err => err)}
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default StateCodeForm;
